import { useNavigate } from "@tanstack/react-router";
import { api } from "../api.js";
import { Import, type ImportDryRun, type ImportResult } from "./Import.js";

/** Import, wired. The screen already talked to these endpoints; this gives it a route. */
export function ImportScreen() {
  const navigate = useNavigate();

  return (
    <Import
      onDryRun={(filename, text) => api.post<ImportDryRun>("/api/import/dry-run", { filename, text })}
      onApply={(runId, options) => api.post<ImportResult>(`/api/import/${runId}/apply`, options)}
      onCancel={async (runId) => {
        await api.post(`/api/import/${runId}/cancel`);
      }}
      // "Start rating" goes to the booth, which is the sentence the receipt ends on.
      onDone={() => void navigate({ to: "/rate" })}
    />
  );
}
